import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import ObjectUtils from '../../../../../../common/helpers/utils/object-utils';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { StoreState } from '@mm/state/store-interfaces';
import { ChatWidgetPreviewIFrameProps } from './ChatWidgetPreviewFrame';
import './ChatWidgetPreviewMessengerIFrame.pcss';

export const ChatWidgetPreviewMessengerIFrame = (
  props: ChatWidgetPreviewIFrameProps,
) => {
  const {
    className,
    chatWidget,
    greetingWidget,
    showGreeting,
    onGreetingShown,
  } = props;

  const { fbAppId } = useSelector((state: StoreState) => state.env);
  const fbPage = useSelector(activeFacebookPageSelector);

  const containerRef = useRef<HTMLDivElement>(null);

  // Listen for loaded
  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.data === 'xbfml.render') {
        onGreetingShown?.();
        if (containerRef.current) {
          containerRef.current.scrollTo(0, 10000);
        }
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  });

  if (!fbPage) {
    return null;
  }

  const srcDoc = `
    <html>
      <head>
      <style type="text/css">
        ${
          showGreeting
            ? ''
            : '#fb-root .fb-customerchat { display: none !important; }'
        }
      </style>
      </head>
      <body>
        <script>
          const promoter=${JSON.stringify(chatWidget)};
          const greetingWidget=${JSON.stringify(
            ObjectUtils.deepSnakeKeys(greetingWidget),
          )};
          const isMobile = false;
          var chatDiv = document.createElement('div');
          chatDiv.className = 'fb-customerchat';
          chatDiv.setAttribute('page_id', ${fbPage.remoteId});
          chatDiv.setAttribute('ref', promoter.searchToken+'_CHATWIDGETPREVIEW=y');
          var greeting = greetingWidget ?
                    greetingWidget.text ||
                    (greetingWidget.attachment && 
                      greetingWidget.attachment.payload &&
                      greetingWidget.attachment.payload.text)
                : promoter.loggedOutGreeting || "Hi! We're here to answer any questions you may have";
          if (greeting) {
            chatDiv.setAttribute('logged_out_greeting', greeting);
            chatDiv.setAttribute('logged_in_greeting', greeting);
          }
    
          if (!isMobile && promoter.greetingDialogDisplay) {
            chatDiv.setAttribute('greeting_dialog_display', promoter.greetingDialogDisplay);
          }
          if (isMobile) {
            if (promoter.greetingDialogDisplayMobile) {
              chatDiv.setAttribute('greeting_dialog_display', promoter.greetingDialogDisplayMobile);
            } else if (promoter.wordpress && promoter.greetingDialogDisplay) {
              chatDiv.setAttribute('greeting_dialog_display', promoter.greetingDialogDisplay);
            }
          }
          ${
            showGreeting
              ? ''
              : "chatDiv.setAttribute('greeting_dialog_display','hide');"
          }
          if (promoter.greetingDialogDelay) {
            chatDiv.setAttribute('greeting_dialog_delay', promoter.greetingDialogDelay);
          }
          if (promoter.color) {
            chatDiv.setAttribute('theme_color', promoter.color);
          }
          document.body.appendChild(chatDiv);
        </script>
        <script>
          function onXfbmlRender(t) {
            window.parent.postMessage('xbfml.render', window.parent.origin);
            setTimeout(()=>FB.CustomerChat.showDialog(), 1000);
          }
          window.fbAsyncInit = function() {
            FB.init({
              appId: '${fbAppId}',
              autoLogAppEvents: true,
              xfbml: true,
              version: 'v6.0',
            });
            FB.Event.subscribe('xfbml.render', onXfbmlRender);
          };
          (function(d, s, id) {
            var js,
              fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
            fjs.parentNode.insertBefore(js, fjs);
          })(document, 'script', 'facebook-jssdk');
        </script>
      </body>
    </html>`;

  return (
    <div
      ref={containerRef}
      className="chat-widget-preview-messenger-iframe__container"
    >
      <iframe
        className={classNames(
          'chat-widget-preview-messenger-iframe__iframe',
          className,
        )}
        title="Chat Widget Preview"
        srcDoc={srcDoc}
      />
    </div>
  );
};
